<button mat-flat-button color="primary" class="lead-submission-btn ml-3 lendio-mat-button-small" (click)="openLeadSubmissionDialog()" data-cy="lead-submission-btn">
	Add New Lead
</button>